'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
require('react');
const hooks_useDimensions = require('../../../hooks/useDimensions.cjs.js');

const tooltip = "_tooltip_yyp1f_9";
const tooltipOpen = "_tooltip-open_yyp1f_1";
const content = "_content_yyp1f_84";
const styles = {
	tooltip: tooltip,
	tooltipOpen: tooltipOpen,
	content: content
};

const singleLineHeightPlusPadding = 28;
const Tooltip = ({ children, allowMultiline = false, "aria-hidden": ariaHidden = void 0, id = void 0, position = "south", zIndex = 2 }) => {
  const [ref, { height }] = hooks_useDimensions.useDimensions();
  const isMultiline = height > singleLineHeightPlusPadding;
  return jsxRuntime.jsx("span", { "aria-hidden": ariaHidden, className: styles.tooltip, "data-testid": `tooltip-${position}`, "data-position": position, "data-multiline": isMultiline, "data-allow-multiline": allowMultiline, "data-zds": true, id, ref, role: "tooltip", style: { zIndex }, children: jsxRuntime.jsx("span", { className: styles.content, "data-multiline": allowMultiline, "data-zds": true, children }) });
};
const TooltipPositionStyles = {
  northwest: { bottom: `calc(100% + var(--zds-space-2))`, left: 0 },
  north: {
    bottom: `calc(100% + var(--zds-space-2))`,
    left: "50%",
    transform: "translateX(-50%)"
  },
  northeast: { bottom: `calc(100% + var(--zds-space-2))`, right: 0 },
  east: {
    left: `calc(100% + var(--zds-space-2))`,
    top: "50%",
    transform: "translateY(-50%)"
  },
  southeast: { top: `calc(100% + var(--zds-space-2))`, right: 0 },
  south: {
    top: `calc(100% + var(--zds-space-2))`,
    left: "50%",
    transform: "translateX(-50%)"
  },
  southwest: { top: `calc(100% + var(--zds-space-2))`, left: 0 },
  west: {
    right: `calc(100% + var(--zds-space-2))`,
    top: "50%",
    transform: "translateY(-50%)"
  }
};

exports.Tooltip = Tooltip;
exports.TooltipPositionStyles = TooltipPositionStyles;
//# sourceMappingURL=Tooltip.cjs.js.map
